diy.angular.registerFactory('diyimageresize', ['$q', function($q) {
    return {
        /**
         * promise based, gets an image based on a file object
         * @param file a File object that should contain an image
         * @returns {promise|a.fn.promise|Q.promise|.n.promise}
         */
        getImageByFile: function(file) {
            var deferred = $q.defer();

            /* for large images loading may same even some
             seconds, this is why we "delay" this */
            setTimeout(function() {
                var fileReader = new FileReader();

                /* on success */
                fileReader.addEventListener('load', function(evt) {
                    var dataUrl = evt.target.result;

                    /* create an image and load it with the dataUrl */
                    var img = document.createElement('img');
                    img.addEventListener('load', function(ev) {
                        deferred.resolve(img);
                    });
                    img.addEventListener('error', function(ev) {
                        deferred.reject();
                    });

                    /* set the dataUrl to the image src */
                    img.src = dataUrl;
                });

                /* when aborted or when an error occurred */
                fileReader.addEventListener('abort', function(evt) {
                    deferred.reject();
                });

                fileReader.addEventListener('error', function(evt) {
                    deferred.reject();
                });

                /* read the file into a data url */
                fileReader.readAsDataURL(file);
            }, 0);

            return deferred.promise;
        },
        /**
         * resize an image client-side
         * @param img the image object
         * @param maxWidth
         * @param maxHeight
         * @returns {string} dataurl src
         */
        resize: function(img, maxWidth, maxHeight) {
            var canvas = document.createElement('canvas');

            var aspectRatio = img.naturalWidth / img.naturalHeight;

            if (aspectRatio > 1) {
                canvas.width = maxWidth;
                canvas.height = maxWidth / aspectRatio;
            } else {
                canvas.height = maxHeight;
                canvas.width = maxHeight * aspectRatio;
            }

            canvas.getContext('2d').drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, canvas.width, canvas.height);
            var thumbStr = canvas.toDataURL();

            img = null;
            canvas = null;

            return thumbStr;
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/angular/services/diyimageresize.js
 ** module id = 932
 ** module chunks = 0
 **/